import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Component({
  selector: 'app-web-destinations-dialog',
  templateUrl: './web-destinations-dialog.component.html',
  styleUrls: ['./web-destinations-dialog.component.scss'],
})
export class WebDestinationsDialogComponent implements OnInit {
  webDestinations: any[] = [];
  location;
  capitalizedLocation;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _authService: AuthServiceLocal,
    private _matSnackBar: MatSnackBar,
    private dialogRef: MatDialogRef<WebDestinationsDialogComponent>
  ) { }

  ngOnInit(): void {
    this.webDestinations = this.data?.webDestinations || [];

    console.log('data', this.data);
    this.location = this.data?.location.locality;
    this.capitalizedLocation =
      this.location.charAt(0).toUpperCase() + this.location.slice(1);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  getNotified(): void {
    const payload = {
      country: localStorage.getItem('country'),
      city: this.data?.location.locality,
    };

    this._authService.getNotified(payload).subscribe((res: any) => {
      if (res.response == 1) {
        this._matSnackBar.open(
          res.message,
          'OKAY',
          {
            duration: 5000,
          }
        );
        this.dialogRef.close();
      }
    });
  }
}
